// this is an autogenerated file from App/Account/Topbar/Tabs/QuickAccess/Tab/Icon/Tasks/Status/data.graphql
import { gql } from 'Data/Api'

export default gql`
subscription app__App_Account_Topbar_Tabs_QuickAccess_Tab_Icon_Tasks_Status($location_id: uuid!) {
  tasks_user_location_pending_tasks(
    where: { location_id: { _eq: $location_id } }
  ) {
    id
    has_pending_tasks
  }
}

`